AOS.init({
    offset: 100,
    duration: 1000,
    // once: true,
});

// scroll位置の調整
const globalNavi = document.getElementById('globalNavi');
let previousScrollPosition = 0;
globalNavi.addEventListener('show.bs.offcanvas', function () {
    previousScrollPosition = window.scrollY;
});
globalNavi.addEventListener('hidden.bs.offcanvas', function () {
    setTimeout(function () {
        window.scrollTo(0, previousScrollPosition);
    }, 0);
});

jQuery(function ($) {
    $('.header_nav .has_menu').hover(function () {
            $(this).find('.header_nav_sub').stop().slideDown();
            $(this).addClass('show');
        }, function () {
            $(this).find('.header_nav_sub').stop().slideUp();
            $(this).removeClass('show');
        }
    );
    $('.main_nav .has_menu').on('click', function () {
        $('.main_nav .has_menu').not(this).removeClass('show').find('.main_nav_sub').slideUp();
        $(this).toggleClass('show').find('.main_nav_sub').slideToggle();
    });

    //scroll event
    $('.js-scrolltop').on('click', function() {
		$("html, body").animate({scrollTop: 0}, 500, 'swing'); 
		return false; 
	});

    //faq
    $('.faq_list dt').on('click',function(){
        $(this).toggleClass('active');
        $(this).next('dd').slideToggle(200);
    });
});
